import { AIChatExperimentWrapper } from '@ecomm/ai-chat/AIChatExperimentWrapper'
import { useIsAIChatExperiment } from '@ecomm/ai-chat/useIsAIChatExperiment'
import { useRef } from 'react'

export function AIChatNavExperimentWrapper() {
  const experimentRef = useRef<HTMLDivElement>(null)
  const {
    isVariant,
    status,
    enabled: isChatEnabled
  } = useIsAIChatExperiment({
    ref: experimentRef
  })

  return (
    <AIChatExperimentWrapper
      enabled={isChatEnabled}
      experimentRef={experimentRef}
      isVariant={isVariant}
      status={status}
    >
      <div
        data-testid="ai-chat-experiment-wrapper"
        className="sr-only"
        aria-hidden="true"
        role="presentation"
      >
        AI Chat Experiment Wrapper
      </div>
    </AIChatExperimentWrapper>
  )
}
